import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import {
    Button,
    makeStyles
} from '@material-ui/core';

import FolderIcon from '@material-ui/icons/Folder';

import ProjectListModal from './ProjectListModal';

const useStyles = makeStyles((theme) => styles(theme));

const propTypes = {

};

const defaultProps = {

};


function ProjectPicker ({}) {
    const classes = useStyles();

    const currentProject = useSelector(state => state.project.currentProject);

    const [isModalOpen, setIsModalOpen] = useState(false);

    return currentProject != null && (
        <div>
            <Button
                variant="outlined"
                startIcon={<FolderIcon />}
                classes={{ root: classes.mainButton}}
                onClick={() => setIsModalOpen(true)}
            >
                {currentProject.name}
            </Button>
            <ProjectListModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </div>
    );
    
}

const styles = theme => ({
    mainButton: {
        height: '100%',
        textTransform: 'none'
    },
});

ProjectPicker.propTypes = propTypes;
ProjectPicker.defaultProps = defaultProps;

export default ProjectPicker;